import React from 'react';
import * as PropTypes from 'prop-types';
import getStyles from './FourBoxSquareForm.styles';
import Resizable from '../Resizable/Resizable';

const FourBoxSquareForm = (props) => {
    const {
        contextStyles,
        formElements,
        onResizeStop,
        scrollIdentifier,
    } = props;

    const {
        anchorScrollColumn,
        mainContentRowSizingContainer,
        column,
        overflowColumn,
    } = getStyles(contextStyles, formElements.length);

    const defaultProps = {
        props: {
            dimensions: {},
            isDetailsView: false,
        },
    };

    const {
        props: {
            viewId: viewId0,
            dimensions: dimensions0,
        },
    } = formElements[0] || defaultProps;
    const {
        props: {
            viewId: viewId1,
            dimensions: dimensions1,
        },
    } = formElements[1] || defaultProps;
    const {
        props: {
            viewId: viewId2,
            dimensions: dimensions2,
        },
    } = formElements[2] || defaultProps;
    const {
        props: {
            viewId: viewId3,
            dimensions: dimensions3,
        },
    } = formElements[3] || defaultProps;

    return (
        <div
            className="anchor-column-scollar-container"
            data-scroll-identifier={ scrollIdentifier }
            style={ anchorScrollColumn }>
            <div
                className="top-row-container"
                key="content-row-container-top"
                style={ { ...mainContentRowSizingContainer } }>
                <Resizable
                    className="left-column-content-top"
                    defaultSize={ {
                        width: dimensions0.width,
                        height: dimensions0.height,
                    } }
                    direction="both"
                    key="left-column-content-top"
                    onResizeStop={ onResizeStop }
                    style={ { ...column, flexBasis: dimensions0.width || '50%' } }
                    viewid={ viewId0 }>
                    { formElements[0] }
                </Resizable>
                <Resizable
                    className="right-column-content-top"
                    defaultSize={ {
                        width: dimensions1.width,
                        height: dimensions1.height,
                    } }
                    direction="both"
                    key="right-column-content-top"
                    onResizeStop={ onResizeStop }
                    style={ { ...column, flexBasis: dimensions1.width || '50%' } }
                    viewid={ viewId1 }>
                    <div style={ { marginLeft: '16px', display: 'flex', flexGrow: 1 } }>
                        { formElements[1] }
                    </div>
                </Resizable>
            </div>
            { formElements.length > 2 &&
                <div
                    className="bottom-row-container"
                    key="content-row-container-bottom"
                    style={ { marginTop: '16px', ...mainContentRowSizingContainer } }>
                    <Resizable
                        className="left-column-content-bottom"
                        defaultSize={ {
                            width: dimensions2.width,
                            height: dimensions2.height,
                        } }
                        direction="both"
                        key="left-column-content-bottom"
                        onResizeStop={ onResizeStop }
                        style={ { ...column, flexBasis: dimensions2.width || '50%' } }
                        viewid={ viewId2 }>
                        { formElements[2] }
                    </Resizable>
                    <Resizable
                        className="right-column-content-bottom"
                        defaultSize={ {
                            width: dimensions3.width,
                            height: dimensions3.height,
                        } }
                        direction="both"
                        key="right-column-content-bottom"
                        onResizeStop={ onResizeStop }
                        style={ { ...column, flexBasis: dimensions3.width || '50%' } }
                        viewid={ viewId3 }>
                        <div style={ { marginLeft: '16px', display: 'flex', flexGrow: 1 } }>
                            { formElements[3] }
                        </div>
                    </Resizable>
                </div>
            }
            { formElements.length > 4 &&
                formElements.slice(4).map((formElement) => {
                    const {
                        props: {
                            dimensions,
                            viewId,
                            isDetailsView,
                        },
                    } = formElement;
                    const minHeightList = isDetailsView ? undefined : { minHeight: '60vh' };
                    return (
                        <Resizable
                            defaultSize={ {
                                width: dimensions.width,
                                height: dimensions.height,
                            } }
                            direction="both"
                            key={ `overflow-content-row-${viewId}` }
                            onResizeStop={ onResizeStop }
                            style={ { marginTop: '16px', ...mainContentRowSizingContainer } }
                            viewid={ viewId }>
                            <div
                                className="overflow-column-content"
                                key={ `left-column-content-bottom-${viewId}` }
                                style={ { ...overflowColumn, ...minHeightList } }>
                                { formElement }
                            </div>
                        </Resizable>
                    );
                })
            }
        </div>
    );
};

FourBoxSquareForm.propTypes = {
    contextStyles: PropTypes.shape({
        anchorScrollColumn: PropTypes.object,
        mainContentRowSizingContainer: PropTypes.object,
        column: PropTypes.object,
        overflowColumn: PropTypes.object,
    }),
    formElements: PropTypes.arrayOf(PropTypes.element),
    scrollIdentifier: PropTypes.string,
    onResizeStop: PropTypes.func,
};

FourBoxSquareForm.defaultProps = {
    contextStyles: {},
    formElements: [],
};

export default FourBoxSquareForm;
